export * from './Page'
export * from './PageContent'
export * from './PageFooter'
export * from './PageHeader'



// WEBPACK FOOTER //
// ./src/shared/components/ui/layouts/index.ts